export const DEFAULT_DEBOUNCE_WAIT_MS = 200;
export const SEARCH_DEBOUNCE_WAIT_MS = 400;
